module.exports = __webpack_public_path__ + "img/sny02.e5d4d6ff.jpg";